export const salon_group_id = 4033;
